export const PAYMENT_METHODS = {
  Card: 'Card',
  Phone: 'Phone',
  APPLE_PAY: 'APPLE_PAY',
  GOOGLE_PAY: 'GOOGLE_PAY',
  applePayLower: 'applepay',
  googlePayLower: 'googlepay',
};

export const PAYMENT_GATEWAYS = {
  ADYEN: 'Adyen',
  STRIPE: 'Stripe',
};

export const PAYMENT_PLANS = {
  daily: 'daily',
  monthly: 'monthly',
  yearly: 'yearly',
  weekly: 'weekly',
  quarterly: 'quarterly',
  semiannually: 'semiannually',
};

export const ENCRYPTED_ADYEN_BILLING_PLANS = {
  monthly: {
    encryptedBillingPlan:
      'eyJiaWxsaW5nT3B0aW9uIjoibW9udGhseSIsInByaWNlIjo4LCJ0cmlhbER1cmF0aW9uIjowLCJhbGxvd0FsbFVzZXJzVG9IYXZlVHJpYWwiOmZhbHNlfQ==',
    amount: 800,
  },
  quarterly: {
    encryptedBillingPlan:
      'eyJiaWxsaW5nT3B0aW9uIjoicXVhcnRlcmx5IiwicHJpY2UiOjI0LCJ0cmlhbER1cmF0aW9uIjowLCJhbGxvd0FsbFVzZXJzVG9IYXZlVHJpYWwiOmZhbHNlfQ==',
    amount: 2400,
  },
  semianually: {
    encryptedBillingPlan:
      'eyJiaWxsaW5nT3B0aW9uIjoic2VtaWFudWFsbHkiLCJwcmljZSI6MzgsInRyaWFsRHVyYXRpb24iOjAsImFsbG93QWxsVXNlcnNUb0hhdmVUcmlhbCI6ZmFsc2V9',
    amount: 3800,
  },
  yearly: {
    encryptedBillingPlan:
      'eyJiaWxsaW5nT3B0aW9uIjoieWVhcmx5IiwicHJpY2UiOjYwLCJ0cmlhbER1cmF0aW9uIjowLCJhbGxvd0FsbFVzZXJzVG9IYXZlVHJpYWwiOmZhbHNlfQ==',
    amount: 6000,
  },
};
